import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../../Pages/PublicModules/NewHome.js";
import Login from "../../Pages/Auth/Login.js";
import UnderMaintenance from "../../Pages/Shared/UnderMaintenance.js";
import PageNotFound from "../../Pages/Shared/PageNotFound.js";
import CreateProject from "../../Pages/AdminModules/ProjectManagement/CreateProject.js";
import SelectKIIQuestionnaireMethod from "../../Pages/AdminModules/KIIQuestionnaire/SelectKIIQuestionnaireMethod.js";
import AllProjects from "../../Pages/AdminModules/ProjectManagement/AllProjects.js";
import Indicators from "../../Pages/PublicModules/Indicators.js";
import About from "../../Pages/PublicModules/About.js";
import Register from "../../Pages/Auth/Register.js";
import Dashboard from "../../Pages/AdminModules/Dashboard.js";
import UserManagement from "../../Pages/AdminModules/UserManagement/UserManagement.js";
import AddUser from "../../Pages/AdminModules/UserManagement/AddUser.js";
import ChangePassword from "../../Pages/Auth/ChangePassword.js";
import ForgotPassword from "../../Pages/Auth/ForgotPassword.js";
import NewPasswordSetter from "../../Pages/Auth/NewPasswordSetter.js";
import Profile from "../../Pages/AdminModules/UserManagement/Profile.js";
import Layout from "../Layouts/Layout.js";
import ProtectedRoute from "./ProtectedRoute.js";
import ManageKII from "../../Pages/AdminModules/KIIManagement/ManageKII.js";
import CreateKII from "../../Pages/AdminModules/KIIManagement/CreateKII.js";

import PermissionManager from "../../Pages/AdminModules/UserManagement/PermissionManager.js";
import NotLoggedInWrapper from "./NotLoggedInWrapper.js";
import KIIQuestionnaireDashboard from "../../Pages/AdminModules/KIIQuestionnaire/KIIQuestionnnaireDashboard.js";
import ViewKIIQuestionnaire from "../../Pages/AdminModules/KIIQuestionnaire/ViewKIIQuestionnaire.js";
import CityProfile from "../../Pages/PublicModules/CityProfile.js";
import KIIDataSubmission from "../../Pages/AdminModules/KIIManagement/KIIDataSubmissionFileUpload.js";
import SurveyDataSubmission from "../../Pages/AdminModules/SurveyManagement/SurveyDataSubmission.js";

import SurveyQuestionnaireDashboard from "../../Pages/AdminModules/SurveyQuestionnaire/SurveyQuestionnnaireDashboard.js";
import SelectSurveyQuestionnaireMethod from "../../Pages/AdminModules/SurveyQuestionnaire/SelectSurveyQuestionnaireMethod.js";
import CreateSurveyQuestionnaire from "../../Pages/AdminModules/SurveyQuestionnaire/CreateSurveyQuestionnaire.js";
import ViewSurveyQuestionnaire from "../../Pages/AdminModules/SurveyQuestionnaire/ViewSurveyQuestionnaire.js";
import CreateKIIQuestionnaire from "../../Pages/AdminModules/KIIQuestionnaire/CreateKIIQuestionnaire.js";
import KIIDataSubmissionCityList from "../../Pages/AdminModules/KIIManagement/KIIDataSubmissionCityList.js";
import DataInsertion from "../../Pages/IMIS Modules/DataInsertion.js";
import IMISDashboardManagment from "../../Pages/IMIS Modules/IMIS Dashboard Management.js";

import SurveyDataSubmissionCityList from "../../Pages/AdminModules/SurveyManagement/SurveyDataSubmissionCityList.js";
import CreateSurvey from "../../Pages/AdminModules/SurveyManagement/CreateSurvey.js";
import ManageSurvey from "../../Pages/AdminModules/SurveyManagement/ManageSurvey.js";
import PermissionProtectedRoute from "./PermissionProtectedRoute.js";
import IMISCities from "../../Pages/AdminModules/IMISCities.js";
import AddIMISUser from "../../Pages/AdminModules/UserManagement/AddIMISUser.js";
import Charts from "../../Pages/PublicModules/Charts.js";
import ManageCityProfile from "../../Pages/AdminModules/CityProfileManagement/index";
import InsertBasicData from "../../Pages/AdminModules/CityProfileManagement/BasicDataInsertion.jsx";
import InsertMapData from "../../Pages/AdminModules/CityProfileManagement/MapDataInsertion.jsx";
import FSTP from "../../Pages/PublicModules/Fstp.js";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout hideNav={true} />}>
          <Route
            path="/login"
            element={
              <NotLoggedInWrapper>
                <Login />
              </NotLoggedInWrapper>
            }
          />

          <Route
            path="/register"
            element={
              <NotLoggedInWrapper>
                <Register />
              </NotLoggedInWrapper>
            }
          />

          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/forgot-password/:token"
            element={<NewPasswordSetter />}
          />
        </Route>

        <Route element={<Layout />}>
          {/* Public routes */}
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/city-profile" element={<CityProfile />} />
          <Route path="/city-comparison" element={<CityProfile />} />
          <Route
            path="/indicators"
            element={<Indicators /> || <UnderMaintenance />}
          />
          <Route path="/charts" element={<Charts />} />
          <Route path="/about" element={<About />} />
          <Route path="/maintenance" element={<UnderMaintenance />} />
          <Route path="/fstp" element={<FSTP />} />

          {/* Protected routes */}

          <Route element={<ProtectedRoute />}>
            <Route index path="/modules" element={<Dashboard />} />
            <Route index path="/imis-cities" element={<IMISCities />} />

            <Route path="/profile" element={<Profile />} />
            <Route path="/change-password" element={<ChangePassword />} />

            {/* PROJECT MODULE URL */}
            <Route
              element={<PermissionProtectedRoute requiredPermission="Survey" />}
            >
              <Route path="/projects" element={<AllProjects />} />
              <Route path="/add-project" element={<CreateProject />} />
            </Route>

            {/* USER MODULE URL */}
            <Route
              element={
                <PermissionProtectedRoute requiredPermission="Super Admin" />
              }
            >
              <Route path="/manage-users" element={<UserManagement />} />
              <Route
                path="/permission-manager/:id"
                element={<PermissionManager />}
              />
              <Route path="/add-user" element={<AddUser />} />
              <Route path="/add-imis-user" element={<AddIMISUser />} />
            </Route>

            {/* KII MODULE URL */}
            <Route
              element={<PermissionProtectedRoute requiredPermission="Kii" />}
            >
              <Route path="/create-kii" element={<CreateKII />} />
              <Route path="/manage-kii" element={<ManageKII />} />
              {/* <Route
                path="/manage-kii/dashboard"
                element={<ManageKIICityDashboard />}
              /> */}
              <Route
                path="/kii-data-submission"
                element={<KIIDataSubmission />}
              />
              <Route
                path="/kii-data-submission-city-list"
                element={<KIIDataSubmissionCityList />}
              />
            </Route>

            {/* KII Questionnaire MODULE URL */}
            <Route
              element={<PermissionProtectedRoute requiredPermission="Kii" />}
            >
              <Route
                path="/kii-questionnaire"
                element={<KIIQuestionnaireDashboard />}
              />
              <Route
                path="/select-kii-questionnaire-method"
                element={<SelectKIIQuestionnaireMethod />}
              />
              <Route
                path="/create-kii-questionnaire"
                element={<CreateKIIQuestionnaire />}
              />
              <Route
                path="/view-kii-questionnaire"
                element={<ViewKIIQuestionnaire />}
              />
            </Route>

            {/* SURVEY MODULE URL */}
            <Route
              element={<PermissionProtectedRoute requiredPermission="Survey" />}
            >
              <Route path="/create-survey" element={<CreateSurvey />} />
              <Route path="/manage-survey" element={<ManageSurvey />} />
              {/* <Route
                path="/manage-survey/dashboard"
                element={<ManageSurveyCityDashboard />}
              /> */}
              <Route
                path="/survey-data-submission-city-list"
                element={<SurveyDataSubmissionCityList />}
              />
              <Route
                path="/survey-data-submission"
                element={<SurveyDataSubmission />}
              />
            </Route>

            {/* SURVEY QUESTIONNAIRE MODULE URL */}
            <Route
              element={<PermissionProtectedRoute requiredPermission="Survey" />}
            >
              <Route
                path="/survey-questionnaire"
                element={<SurveyQuestionnaireDashboard />}
              />
              <Route
                path="/select-survey-questionnaire-method"
                element={<SelectSurveyQuestionnaireMethod />}
              />
              <Route
                path="/create-survey-questionnaire"
                element={<CreateSurveyQuestionnaire />}
              />
              <Route
                path="/view-survey-questionnaire"
                element={<ViewSurveyQuestionnaire />}
              />
            </Route>
          </Route>

          {/* IMIS Routes */}
          <Route
            element={
              <PermissionProtectedRoute requiredPermission="IMIS Data Insertion" />
            }
          >
            <Route path="/data-insertion" element={<DataInsertion />} />
          </Route>
          <Route
            element={
              <PermissionProtectedRoute requiredPermission="IMIS Data Publication" />
            }
          >
            <Route
              path="/imis-dashboard"
              element={<IMISDashboardManagment />}
            />
          </Route>

          <Route
            element={<PermissionProtectedRoute requiredPermission="Survey" />}
          >
            <Route
              path="/manage-cityprofile-data"
              element={<ManageCityProfile />}
            />
            <Route path="/insert-basic-data" element={<InsertBasicData />} />
            <Route path="/insert-map-data" element={<InsertMapData />} />
          </Route>

          {/* WILD CARD */}
          <Route path="*" element={<PageNotFound />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
